import React, { Component } from 'react';
import {
    Paper,
    Box,
    Typography,
    Switch,
    TextField,
    Divider,
    Button
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { toast } from 'react-toastify';

class StoreHours extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInCatalog: false,
            hours: []
        };
    }

    componentDidMount() {

        // Horários padrão caso a conta seja nova e venha vazia ou indefinida via props
        const defaultHours = [
            { day_of_week: 1, label: 'Seg', isOpen: true, open_time: '09:00', close_time: '18:00' },
            { day_of_week: 2, label: 'Ter', isOpen: true, open_time: '09:00', close_time: '18:00' },
            { day_of_week: 3, label: 'Qua', isOpen: true, open_time: '09:00', close_time: '18:00' },
            { day_of_week: 4, label: 'Qui', isOpen: true, open_time: '09:00', close_time: '18:00' },
            { day_of_week: 5, label: 'Sex', isOpen: true, open_time: '09:00', close_time: '18:00' },
            { day_of_week: 6, label: 'Sáb', isOpen: true, open_time: '09:00', close_time: '13:00' },
            { day_of_week: 7, label: 'Dom', isOpen: false, open_time: '09:00', close_time: '18:00' },
        ];

        const propsHours = this.props.data;

        // Se vier da props e tiver itens, usa eles. Se não, usa o padrão para conta nova.
        this.setState({
            hours: (propsHours && propsHours.length > 0) ? propsHours : defaultHours
        });
    }

    handleToggleCatalog = (event) => {
        this.setState({ showInCatalog: event.target.checked });
    };

    handleToggleDay = (index) => {
        const updatedHours = [...this.state.hours];
        updatedHours[index].isOpen = !updatedHours[index].isOpen;
        this.setState({ hours: updatedHours });
    };

    handleChangeTime = (index, field, value) => {
        const updatedHours = [...this.state.hours];
        updatedHours[index][field] = value;
        this.setState({ hours: updatedHours });
    };

    handleSave = () => {
        fetch(`${process.env.REACT_APP_API_URL}/settings/hours`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ hours: this.state.hours }),
        })
            .then(response => {
                if (response.ok) {
                    toast.success('Horários atualizados com sucesso!');
                } else {
                    toast.error('Erro ao atualizar os horários.');
                }
            })
            .catch(error => {
                console.error('Erro ao atualizar os horários:', error);
                toast.error('Erro de conexão ao salvar.');
            });
    };

    render() {
        const { showInCatalog, hours } = this.state;

        return (
            <Box>
                {/* Cabeçalho */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <AccessTimeIcon color="action" />
                        <Typography variant="subtitle1" fontWeight="500" color="text.secondary">
                            Horário de Funcionamento
                        </Typography>
                    </Box>

                </Box>

                {/* Lista de Dias */}
                <Paper variant="outlined" sx={{ borderRadius: 2, borderColor: '#e0e0e0', overflow: 'hidden' }}>
                    {hours.map((item, index) => (
                        <React.Fragment key={item.day_of_week}>
                            <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                px={3}
                                py={1.5}
                                sx={{ backgroundColor: '#fff', '&:hover': { backgroundColor: '#fafafa' } }}
                            >
                                {/* Switch e Dia da Semana */}
                                <Box display="flex" alignItems="center" gap={2} minWidth={100}>
                                    <Switch
                                        checked={item.isOpen}
                                        onChange={() => this.handleToggleDay(index)}
                                        color="primary"
                                    />
                                    <Typography
                                        variant="body1"
                                        fontWeight="500"
                                        color={item.isOpen ? 'text.primary' : 'text.disabled'}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>

                                {/* Campos de Horário */}
                                <Box display="flex" alignItems="center" gap={2}>
                                    <TextField
                                        type="time"
                                        size="small"
                                        disabled={!item.isOpen}
                                        value={item.open_time}
                                        onChange={(e) => this.handleChangeTime(index, 'open_time', e.target.value)}
                                        InputProps={{
                                            sx: { borderRadius: '20px', backgroundColor: item.isOpen ? '#fcfcfc' : '#f5f5f5' }
                                        }}
                                        sx={{ width: 130 }}
                                    />

                                    <Typography variant="body2" color="text.secondary">
                                        às
                                    </Typography>

                                    <TextField
                                        type="time"
                                        size="small"
                                        disabled={!item.isOpen}
                                        value={item.close_time}
                                        onChange={(e) => this.handleChangeTime(index, 'close_time', e.target.value)}
                                        InputProps={{
                                            sx: { borderRadius: '20px', backgroundColor: item.isOpen ? '#fcfcfc' : '#f5f5f5' }
                                        }}
                                        sx={{ width: 130 }}
                                    />
                                </Box>
                            </Box>
                            {index < hours.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </Paper>

                {/* Botão de Salvar */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        mt: 4,
                        pt: 2,
                        borderTop: '1px solid #eee'
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={this.handleSave}
                        startIcon={<SaveOutlinedIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '8px',
                            bgcolor: '#6200ee',
                            px: 4,
                            '&:hover': { bgcolor: '#4a00b8' }
                        }}
                    >
                        Salvar
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default StoreHours;